import 'css/ui/label.css';
import BaseUIComponent from 'ui/baseUIComponent';

export default class Label extends BaseUIComponent {
  constructor (x,y, className = 'label') {
    super();

    this.element = this._createDiv(className);

    this.setPosition(x,y);
  }

  setPosition (x,y) {
    this.element.style.top = y + 'px';
    this.element.style.left = x + 'px';
  }

  setText (text) {
    this.element.innerHTML = text;
  }

  _createDiv (className) {
    const label = document.createElement('div');
    label.innerHTML = '0';
    label.className = className;
    this.parent.appendChild(label);
    return label;
  }
}



// WEBPACK FOOTER //
// ./src/ui/label.js